import React from 'react'

import AlertIcon from '../../images/alert.svg'
import NotFoundIcon from '../../images/not-found.svg'

export const PageNotFound: React.FC = () => {
  return (
    <div className='onlinepbx__page__not__found'>
      <div className='onlinepbx__head'>
        <div className='onlinepbx__container'>
          <h2 className='onlinepbx__content__header__center onlinepbx__page__not__found__header'>
            <AlertIcon className='onlinepbx__page__not__found__alert' /> Такой страницы не существует
          </h2>
          <div className='onlinepbx__page__not__found__text'>
            По статистике 30% клиентов не перезванивают, если не дозвонились. Мы зафиксируем все пропущенные и подскажем, кому вы не перезвонили.
          </div>
          <div className='onlinepbx__page__not__found__block'>
            <div className='onlinepbx__page__not__found__content'>
              <NotFoundIcon className='onlinepbx__page__not__found__icon' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageNotFound
